/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceFromJSON, FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreference';
/**
 * Check if a given object implements the FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts interface.
 */
export function instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts(value) {
    if (!('PowerPreference' in value) || value['PowerPreference'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Alpha': json['Alpha'] == null ? undefined : json['Alpha'],
        'Antialias': json['Antialias'] == null ? undefined : json['Antialias'],
        'Depth': json['Depth'] == null ? undefined : json['Depth'],
        'FailIfMajorPerformanceCaveat': json['FailIfMajorPerformanceCaveat'] == null ? undefined : json['FailIfMajorPerformanceCaveat'],
        'PowerPreference': FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceFromJSON(json['PowerPreference']),
        'PremultipliedAlpha': json['PremultipliedAlpha'] == null ? undefined : json['PremultipliedAlpha'],
        'PreserveDrawingBuffer': json['PreserveDrawingBuffer'] == null ? undefined : json['PreserveDrawingBuffer'],
        'Stencil': json['Stencil'] == null ? undefined : json['Stencil'],
        'Desynchronized': json['Desynchronized'] == null ? undefined : json['Desynchronized'],
        'XrCompatible': json['XrCompatible'] == null ? undefined : json['XrCompatible'],
    };
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Alpha': value['Alpha'],
        'Antialias': value['Antialias'],
        'Depth': value['Depth'],
        'FailIfMajorPerformanceCaveat': value['FailIfMajorPerformanceCaveat'],
        'PowerPreference': FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsPowerPreferenceToJSON(value['PowerPreference']),
        'PremultipliedAlpha': value['PremultipliedAlpha'],
        'PreserveDrawingBuffer': value['PreserveDrawingBuffer'],
        'Stencil': value['Stencil'],
        'Desynchronized': value['Desynchronized'],
        'XrCompatible': value['XrCompatible'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts.js.map